import React from 'react';
import { SearchInputColumn } from 'components';

export const getColumns = (handleSearchColumn) => [
    {
        id: 'stt',
        numeric: true,
        label: 'STT',
        align: 'center',
        width: 10,
    },
    {
        id: 'kpiName',
        disabelPadding: false,
        label: (
            <SearchInputColumn
                title="Tên KPI"
                name="kpiName"
                onChange={handleSearchColumn}
            />
        ),
        align: 'center',
        width: '100px',
    },
    {
        id: 'unit',
        label: 'Đơn vị',
        align: 'center',
        width: '100px',
    },
    {
        id: 'quantity',
        numeric: true,
        label: 'Số lượng',
        align: 'center',
        width: '100px',
        render: (row) => row.quantity,
    },
    {
        id: 'target',
        numeric: true,
        label: 'Target',
        align: 'center',
        width: '100px',
        render: (row) => row.target,
    },
    {
        id: 'percentAchieved',
        numeric: true,
        label: '% Đạt',
        align: 'center',
        width: '100px',
        render: (row) => row.percentAchieved,
    },
];
